var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "translate(0 0.5)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 4,
    stroke: "#177C9A",
    strokeWidth: 1.5,
    strokeLinecap: "butt"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33788 18.3206C5.99897 15.5269 8.77173 14 11.6426 14H12.3574C15.2283 14 18.001 15.5269 18.6621 18.3206C18.79 18.8611 18.8917 19.4268 18.9489 20.0016C19.0036 20.5512 18.5523 21 18 21H6C5.44772 21 4.99642 20.5512 5.0511 20.0016C5.1083 19.4268 5.20997 18.8611 5.33788 18.3206Z",
    stroke: "#177C9A",
    strokeWidth: 1.5,
    strokeLinecap: "butt"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/userProfile.4954865c24586c5265e59e05e6a6849c.svg";
export { ForwardRef as ReactComponent };